// @ts-nocheck
// Química Visual™ — Landing Edición LATAM (relanzamiento)
// Pegar este archivo completo reemplazando el contenido de App.tsx en Magic Patterns.
import { useEffect } from "react";
const CSS = `
:root{
  --navy:#0b1b3a; --petrol:#0f6a82; --blue:#2563eb; --turq:#14b8a6;
  --green:#16a34a; --green-d:#15803d; --gold:#f5b83d;
  --bg:#eef8fb; --ice:#ddf1f6; --card:#fff; --text:#334155; --muted:#64748b; --line:#dbe7ee;
  --r:20px; --shadow:0 10px 30px -12px rgba(11,27,58,.18);
}
*{box-sizing:border-box;margin:0;padding:0}
html{scroll-behavior:smooth}
body{font-family:Inter,system-ui,sans-serif;color:var(--text);background:var(--bg);line-height:1.55;-webkit-font-smoothing:antialiased;overflow-x:hidden}
img{max-width:100%;display:block}
h1,h2,h3,.ff{font-family:Poppins,Inter,sans-serif;color:var(--navy);line-height:1.15;letter-spacing:-.01em}
h1{font-size:clamp(2rem,6vw,3.6rem);font-weight:900}
h2{font-size:clamp(1.6rem,4.2vw,2.6rem);font-weight:800}
h3{font-size:1.08rem;font-weight:700}
.accent{color:var(--blue)}
.wrap{max-width:1100px;margin:0 auto;padding:0 16px}
.narrow{max-width:780px;margin:0 auto}
section{padding:64px 0}
.center{text-align:center}
.lead{font-size:1.1rem;color:var(--muted);max-width:720px;margin:14px auto 0}
.eyebrow{display:inline-flex;align-items:center;gap:6px;font-size:.78rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--petrol);margin-bottom:12px}
.pill{display:inline-block;padding:6px 14px;border-radius:999px;background:#fff;border:1px solid var(--line);font-size:.85rem;font-weight:600;color:var(--petrol)}
.grid{display:grid;gap:18px}
.g2{grid-template-columns:repeat(auto-fit,minmax(280px,1fr))}
.g3{grid-template-columns:repeat(auto-fit,minmax(250px,1fr))}
.g4{grid-template-columns:repeat(auto-fit,minmax(200px,1fr))}
.card{background:var(--card);border-radius:var(--r);padding:24px;box-shadow:var(--shadow);border:1px solid #fff}
.num{width:36px;height:36px;border-radius:50%;background:var(--petrol);color:#fff;font-weight:700;display:grid;place-items:center;font-size:.85rem;margin-bottom:14px}
.ico{width:48px;height:48px;border-radius:14px;display:grid;place-items:center;font-size:1.4rem;margin-bottom:14px}
.card p{font-size:.95rem;color:var(--muted);margin-top:6px}

/* Botones */
.btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;background:var(--green);color:#fff;font-family:Poppins,sans-serif;font-weight:800;text-transform:uppercase;font-size:1.05rem;padding:18px 34px;border-radius:16px;text-decoration:none;box-shadow:0 12px 28px -8px rgba(22,163,74,.55);transition:transform .15s,background .15s;border:0;cursor:pointer;text-align:center}
.btn:hover{background:var(--green-d);transform:translateY(-2px)}
.btn.big{font-size:1.25rem;padding:22px 40px;width:100%;max-width:640px}
.cta-note{font-size:.88rem;color:var(--petrol);font-weight:600;margin-top:12px}
.cta-sub{font-size:.82rem;color:var(--muted);margin-top:6px}

/* Barra superior */
.topbar{background:var(--navy);color:#fff;font-size:.85rem;font-weight:600;text-align:center;padding:9px 16px}
.topbar img{display:inline-block;width:18px;height:auto;vertical-align:-2px;margin-right:6px;border-radius:2px}

/* Hero */
.hero{padding:44px 0 56px;background:linear-gradient(180deg,#f3fbfd 0%,var(--bg) 100%)}
.hero .sub{font-size:clamp(1.05rem,2.4vw,1.3rem);font-weight:600;color:var(--navy);max-width:760px;margin:18px auto 0}
.hero .desc{color:var(--muted);max-width:700px;margin:12px auto 0}
.mock{max-width:620px;margin:30px auto 0;border-radius:28px;overflow:hidden;box-shadow:0 30px 60px -20px rgba(11,27,58,.35);border:1px solid #fff}
.chips{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin:22px 0}
.hero-price{display:inline-flex;align-items:baseline;gap:10px;flex-wrap:wrap;justify-content:center;margin:6px 0 18px}
.hero-price .old{text-decoration:line-through;color:var(--muted);font-weight:600}
.hero-price .now{font-family:Poppins,sans-serif;font-weight:800;font-size:1.5rem;color:var(--navy)}
.trust4{margin-top:34px}
.trust4 .card{padding:18px;text-align:center;font-family:Poppins,sans-serif;font-weight:700;color:var(--navy);font-size:.9rem;text-transform:uppercase}
.trust4 .card span{display:block;font-size:1.5rem;margin-bottom:6px}

.hero-checks{list-style:none;display:grid;width:fit-content;max-width:100%;gap:10px;text-align:left;margin:22px auto 14px;font-weight:600;color:var(--navy)}
.hero-checks li{display:flex;gap:10px;align-items:flex-start}
.hero-checks li::before{content:"✓";flex:0 0 24px;height:24px;border-radius:50%;background:var(--green);color:#fff;display:grid;place-items:center;font-size:.8rem;font-weight:800}
.hero .mock-wrap{margin-top:64px}/* Temas */
.topics{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-top:22px}
.topics span{background:#fff;border:1px solid var(--line);border-radius:10px;padding:8px 12px;font-size:.9rem;font-weight:600;color:var(--navy)}

/* Citas reales */
.quote{display:flex;flex-direction:column;justify-content:space-between}
.quote blockquote{font-family:Poppins,sans-serif;font-weight:600;color:var(--navy);font-size:1.02rem;line-height:1.45}
.quote .who{margin-top:16px;padding-top:14px;border-top:1px solid var(--line);font-size:.88rem}
.quote .who b{color:var(--navy);display:block}
.stars{color:var(--gold);letter-spacing:2px;margin-bottom:10px}

/* Comparación */
.compare{background:var(--ice)}
.vs .bad{background:#f8fbfc}
.vs .good{background:var(--petrol);color:#fff}
.vs .good h3{color:#fff}
.vs ul{list-style:none;margin-top:16px;display:grid;gap:14px}
.vs li{display:flex;gap:12px;align-items:flex-start;font-size:.97rem}
.vs li i{flex:0 0 26px;height:26px;border-radius:8px;display:grid;place-items:center;font-style:normal;font-weight:700;font-size:.85rem}
.vs .bad li i{background:#e2e8f0;color:#475569}
.vs .good li i{background:rgba(20,184,166,.25);color:#99f6e4}

/* Biblioteca */
.lib .card h3{text-transform:uppercase;font-size:1rem}
.moments{background:var(--navy);border-radius:28px;padding:34px 22px;margin-top:28px}
.moments h3{color:#fff;text-align:center;font-size:1.4rem;margin-bottom:22px}
.moments .m{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1);border-radius:16px;padding:18px;color:#cbd5e1;font-size:.93rem}
.moments .m b{display:block;color:var(--turq);font-family:Poppins,sans-serif;text-transform:uppercase;margin-bottom:4px}

/* Carrusel */
.samples{background:var(--ice)}
.car{position:relative;max-width:900px;margin:30px auto 0}
.track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;gap:16px;scrollbar-width:none;border-radius:24px}
.track::-webkit-scrollbar{display:none}
.slide{flex:0 0 100%;scroll-snap-align:center;background:#fff;border-radius:24px;padding:18px;box-shadow:var(--shadow)}
.slide img{width:100%;height:auto;max-height:560px;object-fit:contain;border-radius:12px;background:#f8fafc}
.slide p{text-align:center;font-family:Poppins,sans-serif;font-weight:700;color:var(--navy);margin-top:12px}
.slide small{display:block;text-align:center;color:var(--muted);font-weight:600;letter-spacing:.06em;font-size:.72rem;text-transform:uppercase}
.arr{position:absolute;top:45%;transform:translateY(-50%);width:46px;height:46px;border-radius:50%;background:#fff;border:0;box-shadow:var(--shadow);font-size:1.3rem;color:var(--petrol);cursor:pointer;z-index:2}
.arr.prev{left:-10px}.arr.next{right:-10px}
.dots{display:flex;justify-content:center;gap:7px;margin-top:16px}
.dots button{width:9px;height:9px;border-radius:99px;border:0;background:#b6cbd5;cursor:pointer;transition:width .2s}
.dots button.on{width:26px;background:var(--petrol)}

/* Cuadernillos */
.book{display:flex;gap:14px;align-items:flex-start;background:#fff;border:1px solid var(--line);border-radius:16px;padding:16px 18px}
.book .n{flex:0 0 40px;height:40px;border-radius:12px;background:var(--ice);display:grid;place-items:center;font-family:Poppins,sans-serif;font-weight:800;color:var(--petrol)}
.book b{font-family:Poppins,sans-serif;color:var(--navy);font-size:.95rem;text-transform:uppercase}
.book p{font-size:.9rem;color:var(--muted);margin-top:2px}
.badge{display:inline-block;background:var(--gold);color:var(--navy);font-weight:800;font-size:.75rem;letter-spacing:.08em;padding:6px 14px;border-radius:999px;text-transform:uppercase;margin-bottom:14px}
.closing-line{font-family:Poppins,sans-serif;font-weight:700;color:var(--petrol);font-size:1.15rem;margin-top:26px}

/* Testimonios */
.wa{display:grid;grid-template-columns:repeat(3,1fr);gap:18px;margin-top:30px}
.wa img{border-radius:22px;box-shadow:var(--shadow);width:100%;height:auto;background:#fff}

/* Decisión */
.decide{background:var(--ice)}
.calc{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:16px;margin-top:28px}
.calc .card{text-align:center}
.calc .big{font-family:Poppins,sans-serif;font-weight:900;font-size:2.2rem;color:var(--petrol);line-height:1}
.calc .big.g{color:var(--green)}

/* Oferta */
.offer{border:2px solid var(--petrol);border-radius:26px;background:#fff;padding:30px 24px;box-shadow:var(--shadow);text-align:left}
.offer .tag{display:inline-block;background:var(--green);color:#fff;font-size:.72rem;font-weight:800;letter-spacing:.06em;padding:5px 12px;border-radius:999px;text-transform:uppercase}
.offer h3{font-size:1.35rem;margin:12px 0 4px}
.offer ul{list-style:none;margin:18px 0;display:grid;gap:10px}
.offer li{display:flex;gap:10px;font-size:1rem}
.offer li::before{content:"✓";color:var(--green);font-weight:800}
.pricebox{border-top:1px solid var(--line);padding-top:18px;margin-top:8px}
.pricebox .old{text-decoration:line-through;color:var(--muted);font-weight:700;font-size:1.05rem}
.pricebox .now{font-family:Poppins,sans-serif;font-weight:900;font-size:clamp(2.2rem,7vw,3rem);color:var(--navy);line-height:1.1}
.pricebox .loc{display:flex;align-items:center;gap:8px;font-size:.88rem;color:var(--petrol);font-weight:600;margin-top:6px}
.pricebox .loc img{width:20px;border-radius:2px}
.pricebox .usd{font-size:.85rem;color:var(--muted);margin-top:4px}
.guar{display:flex;gap:22px;align-items:center;background:#fff;border-radius:24px;padding:24px;box-shadow:var(--shadow);margin-top:30px;text-align:left}
.guar img{width:110px;flex:0 0 110px}

/* FAQ */
.faq details{background:#fff;border-radius:16px;margin-bottom:12px;box-shadow:0 4px 14px -8px rgba(11,27,58,.15)}
.faq summary{list-style:none;cursor:pointer;padding:20px 22px;font-family:Poppins,sans-serif;font-weight:700;color:var(--navy);display:flex;justify-content:space-between;gap:16px}
.faq summary::-webkit-details-marker{display:none}
.faq summary::after{content:"+";color:var(--petrol);font-size:1.4rem;line-height:1}
.faq details[open] summary::after{content:"–"}
.faq details p{padding:0 22px 20px;color:var(--muted)}

/* Cierre */
.final{background:var(--navy);color:#cbd5e1;text-align:center}
.final h2{color:#fff;font-size:clamp(2rem,6vw,3.4rem);font-weight:900}
.final h2 span{color:var(--turq)}
.final .sub{color:#fff;font-weight:700;font-size:1.2rem;margin-top:14px}
.final .meta{font-size:.78rem;letter-spacing:.08em;text-transform:uppercase;color:#94a3b8;margin-top:18px;font-weight:600}
footer{background:var(--navy);border-top:1px solid rgba(255,255,255,.08);text-align:center;padding:34px 16px 110px;color:#94a3b8;font-size:.8rem}
footer b{color:var(--turq);letter-spacing:.1em;font-family:Poppins,sans-serif}

/* Barra fija móvil */
.sticky{position:fixed;left:0;right:0;bottom:0;background:#fff;border-top:1px solid var(--line);box-shadow:0 -8px 24px -12px rgba(11,27,58,.25);padding:10px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px;z-index:50;transform:translateY(110%);transition:transform .25s}
.sticky.show{transform:none}
.sticky .despues-oferta{display:none}.sticky.pasada .despues-oferta{display:block}.sticky.pasada a.despues-oferta{display:inline-flex}.sticky.pasada .antes-oferta{display:none}
.sticky .p{font-family:Poppins,sans-serif;font-weight:800;color:var(--navy);font-size:1.05rem;line-height:1.1}
.sticky .p small{display:block;font-family:Inter,sans-serif;font-weight:500;font-size:.72rem;color:var(--muted)}
.sticky .btn{padding:13px 18px;font-size:.9rem;border-radius:12px;white-space:nowrap}

/* ===== INTERACCIÓN ===== */
/* Capa de partículas: no bloquea clics y queda muy tenue para no tapar el texto */
#particulas{position:fixed;inset:0;pointer-events:none;z-index:40;overflow:hidden}
.pt{position:absolute;opacity:var(--o,.16);animation:flotar var(--t,26s) ease-in-out infinite alternate;will-change:transform}
.pt svg{display:block;width:100%;height:100%}
@keyframes flotar{
  0%{transform:translate(0,0) rotate(0)}
  33%{transform:translate(var(--dx1),var(--dy1)) rotate(40deg)}
  66%{transform:translate(var(--dx2),var(--dy2)) rotate(-25deg)}
  100%{transform:translate(var(--dx3),var(--dy3)) rotate(15deg)}
}
.orb{transform-origin:50px 50px;animation:girar var(--g,6s) linear infinite}
.orb.r{animation-direction:reverse}
@keyframes girar{to{transform:rotate(360deg)}}

/* Botones CTA: pulso suave + brillo que cruza + flecha que se mueve */
.btn{position:relative;overflow:hidden;animation:pulso 2.6s ease-in-out infinite}
.btn::after{content:"";position:absolute;top:0;left:-60%;width:40%;height:100%;background:linear-gradient(110deg,transparent,rgba(255,255,255,.45),transparent);transform:skewX(-20deg);animation:brillo 3.8s ease-in-out infinite}
.btn .fl{display:inline-block;transition:transform .2s;animation:empuje 1.6s ease-in-out infinite}
.btn:hover{transform:translateY(-3px) scale(1.02)}
.btn:active{transform:scale(.97)}
@keyframes pulso{0%,100%{box-shadow:0 12px 28px -8px rgba(22,163,74,.55),0 0 0 0 rgba(22,163,74,.45)}50%{box-shadow:0 12px 28px -8px rgba(22,163,74,.55),0 0 0 12px rgba(22,163,74,0)}}
@keyframes brillo{0%,55%{left:-60%}85%,100%{left:130%}}
@keyframes empuje{0%,100%{transform:translateX(0)}50%{transform:translateX(5px)}}

/* Tarjetas: se elevan al pasar el mouse */
.card,.book,.slide{transition:transform .25s,box-shadow .25s}
.card:hover,.book:hover{transform:translateY(-5px);box-shadow:0 22px 40px -18px rgba(11,27,58,.3)}
.topics span{transition:transform .2s,background .2s,color .2s}
.topics span:hover{transform:translateY(-3px) rotate(-1deg);background:var(--petrol);color:#fff}

/* Mockup flotando con un átomo orbitando detrás */
.mock-wrap{position:relative;max-width:620px;margin:30px auto 0}
.mock-wrap .mock{margin:0;animation:levitar 6s ease-in-out infinite;position:relative;z-index:1}
.mock-wrap .anillo{position:absolute;inset:-6%;border:2px dashed rgba(37,99,235,.25);border-radius:50%;animation:girar 40s linear infinite}
.mock-wrap .anillo i{position:absolute;top:-9px;left:50%;width:18px;height:18px;border-radius:50%;background:var(--turq);box-shadow:0 0 14px var(--turq)}
@keyframes levitar{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}

/* Aparición al hacer scroll (solo si hay JS) */
.js .rv{opacity:0;transform:translateY(26px);transition:opacity .7s ease,transform .7s ease}
.js .rv.in{opacity:1;transform:none}

/* Respeta a quien prefiere menos movimiento */
@media (prefers-reduced-motion:reduce){
  *,*::before,*::after{animation:none!important;transition:none!important}
  #particulas{display:none}
  .js .rv{opacity:1;transform:none}
}

@media (max-width:760px){
  section{padding:48px 0}
  .mock-wrap .anillo{display:none}
  .wa{grid-template-columns:1fr;max-width:380px;margin-left:auto;margin-right:auto}
  .guar{flex-direction:column;text-align:center}
  .arr{display:none}
  .btn{width:100%}
  .moments{padding:26px 16px}
}
@media (min-width:761px){.sticky{display:none}}
`;
const MARKUP = `<div class="topbar" id="topbar">🌎 Disponible en toda Latinoamérica · Acceso digital inmediato</div>

<!-- HERO -->
<header class="hero center">
  <div class="wrap">
    <span class="pill">🧪 Para docentes de Química de secundaria</span>
    <h1 style="margin-top:18px">Enseñar Química ya es suficiente.<br><span class="accent">Prepararla no debería robarte las tardes.</span></h1>
    <p class="sub">Buscar actividades, adaptar guías, armar evaluaciones A y B… Ya lo hicimos por ti. Más de 200 actividades de Química listas para imprimir y usar mañana mismo.</p>

    <ul class="hero-checks">
      <li>Sin buscar en Google ni en carpetas viejas</li>
      <li>Evaluaciones A y B ya armadas</li>
      <li>Fichas visuales que tus alumnos entienden</li>
    </ul>

    <a class="btn big cta" href="#oferta">Quiero los recursos listos</a>
    <p class="cta-note">Pago único · Acceso inmediato · Garantía de 7 días</p>

    <div class="mock-wrap">
      <div class="anillo"><i></i></div>
      <div class="mock">
        <img src="https://cdn.magicpatterns.com/uploads/xbhcoYSmVqjJPc29whzi3T/quimica_visual_mockup_principal_v1.webp" alt="Química Visual: más de 200 actividades de Química listas para imprimir" width="1200" height="1200">
      </div>
    </div>

    <div class="chips">
      <span class="pill">Fichas visuales</span><span class="pill">Actividades A y B</span><span class="pill">Juegos</span><span class="pill">Evaluaciones</span><span class="pill">Historietas científicas</span>
    </div>

    <div class="grid g4 trust4">
      <div class="card"><span>🖨️</span>100% imprimible</div>
      <div class="card"><span>🅰️🅱️</span>Actividades A y B</div>
      <div class="card"><span>🎲</span>Juegos e historietas</div>
      <div class="card"><span>⚡</span>Acceso inmediato</div>
    </div>
  </div>
</header>

<!-- TEMAS -->
<section style="padding-top:20px">
  <div class="wrap center">
    <span class="eyebrow">⚛️ Temas que cubre</span>
    <h2>Los contenidos de Química que das todo el año</h2>
    <div class="topics">
      <span>Materia y sistemas materiales</span><span>Estados y cambios</span><span>Estructura atómica</span><span>Tabla periódica</span><span>Configuración electrónica</span><span>Enlaces químicos</span><span>Nomenclatura inorgánica</span><span>Reacciones y balanceo</span><span>Estequiometría</span><span>Soluciones</span><span>Ácidos y bases</span><span>Química orgánica</span>
    </div>
  </div>
</section>

<!-- CITAS REALES -->
<section style="padding-top:0">
  <div class="wrap">
    <div class="grid g3">
      <div class="card quote">
        <div><div class="stars">★★★★★</div><blockquote>“Normalmente se distraen mucho, pero como el material es tan visual, captaste su atención rápido. ¡Ahorré horas de búsqueda!”</blockquote></div>
        <div class="who"><b>Prof. Ximena</b>Ciudad de México · secundaria</div>
      </div>
      <div class="card quote">
        <div><div class="stars">★★★★★</div><blockquote>“Las fichas ilustrativas me ahorraron todo el trabajo de hacer diagramas en el tablero. Todo está muy bien estructurado.”</blockquote></div>
        <div class="who"><b>Profe Beatriz</b>Medellín, Colombia</div>
      </div>
      <div class="card quote">
        <div><div class="stars">★★★★★</div><blockquote>“Enhorabuena por el diseño de las fichas, se nota que hay mucho trabajo detrás. Hacía falta material así.”</blockquote></div>
        <div class="who"><b>Javi · Profe de Física y Química</b>Valencia, España</div>
      </div>
    </div>
  </div>
</section>

<!-- PÚBLICO / DOLOR -->
<section style="padding-top:10px">
  <div class="wrap">
    <div class="center narrow">
      <h2>Química Visual fue creada para docentes que quieren enseñar mejor sin dedicar más horas a planificar.</h2>
      <p class="lead">Si das Química en secundaria, sabes que una buena clase no se resuelve solo con una explicación: necesitas ejemplos, actividades, práctica, evaluación, alternativas para recuperar y recursos que ayuden a tus estudiantes a comprender lo que ven.</p>
    </div>
    <div class="grid g3" style="margin-top:34px">
      <div class="card"><div class="num">01</div><h3>Preparas uno o varios cursos</h3><p>Necesitas el contenido adecuado para cada nivel sin revisar archivos, libros y carpetas durante horas.</p></div>
      <div class="card"><div class="num">02</div><h3>Tus tardes se van en planificar</h3><p>Buscas materiales ya pensados para imprimir, adaptar a tu grupo y usar sin empezar con una hoja en blanco.</p></div>
      <div class="card"><div class="num">03</div><h3>Tus estudiantes se pierden con la teoría sola</h3><p>Quieres explicar átomos, enlaces, compuestos, reacciones y cálculos con apoyos visuales, ejemplos y consignas claras.</p></div>
      <div class="card"><div class="num">04</div><h3>Necesitas actividades diferentes</h3><p>Quieres salir de las guías repetidas y proponer desafíos, juegos, análisis y situaciones que invitan a participar.</p></div>
      <div class="card"><div class="num">05</div><h3>Quieres evaluar con más orden</h3><p>Necesitas versiones A y B, propuestas de práctica y recursos que faciliten el seguimiento y la recuperación.</p></div>
      <div class="card" style="background:var(--petrol);color:#fff;display:flex;align-items:center"><p style="color:#fff;font-family:Poppins,sans-serif;font-weight:700;font-size:1.1rem;margin:0">Tu próxima clase no tiene que empezar con una búsqueda interminable ni con otra noche creando material.</p></div>
    </div>
  </div>
</section>

<!-- COMPARACIÓN -->
<section class="compare">
  <div class="wrap">
    <div class="center narrow">
      <h2>La diferencia entre seguir armando todo desde cero y tener una biblioteca lista para usar.</h2>
      <p class="lead">No necesitas más recursos dispersos. Necesitas un sistema que te permita encontrar y utilizar lo que necesitas para cada clase.</p>
    </div>
    <div class="grid g2 vs" style="margin-top:34px">
      <div class="card bad">
        <h3>Cuando cada clase empieza desde cero</h3>
        <ul>
          <li><i>✕</i>Pasas horas buscando actividades que luego debes adaptar.</li>
          <li><i>✕</i>Guardas recursos dispersos entre carpetas, archivos, libros y enlaces.</li>
          <li><i>✕</i>Repites las mismas propuestas porque no tienes tiempo de crear alternativas.</li>
          <li><i>✕</i>Preparas evaluación y recuperación como tareas separadas cada vez.</li>
          <li><i>✕</i>La planificación ocupa el tiempo que querías para ti, tu descanso o tu familia.</li>
        </ul>
      </div>
      <div class="card good">
        <h3>Con Química Visual™</h3>
        <ul>
          <li><i>✓</i>Encuentras fichas, actividades, juegos y evaluaciones organizadas por tema.</li>
          <li><i>✓</i>Preparas una clase concreta sin empezar desde una página en blanco.</li>
          <li><i>✓</i>Combinas explicación visual, práctica y evaluación en un mismo sistema.</li>
          <li><i>✓</i>Usas las versiones A y B cuando necesitas una alternativa para trabajar o recuperar.</li>
          <li><i>✓</i>Recuperas tiempo de planificación sin bajar la calidad de tus clases.</li>
        </ul>
      </div>
    </div>
    <div class="center" style="margin-top:32px">
      <p class="ff" style="font-weight:800;font-size:1.25rem;margin-bottom:20px">Menos tiempo buscando y preparando. Más tiempo enseñando.</p>
      <a class="btn cta" href="#oferta">Quiero tener los recursos listos</a>
    </div>
  </div>
</section>

<!-- BIBLIOTECA -->
<section class="lib">
  <div class="wrap">
    <div class="center narrow">
      <span class="eyebrow">🧪 Qué incluye</span>
      <h2>Más de 200 actividades organizadas.<br><span class="accent">Una biblioteca que resuelve tus clases.</span></h2>
      <p class="lead">El corazón de Química Visual son los materiales listos para imprimir y usar. Elige el tema, toma el recurso que necesitas y entra a clase con una propuesta clara.</p>
    </div>
    <div class="grid g3" style="margin-top:34px">
      <div class="card"><div class="ico" style="background:#e0f2f7">⚛️</div><h3>Fichas visuales</h3><p>Esquemas, ejemplos y apoyos visuales para explicar contenidos complejos con mayor claridad.</p></div>
      <div class="card"><div class="ico" style="background:#dbeafe">🅰️</div><h3>Actividades A y B</h3><p>Propuestas listas para practicar, evaluar y recuperar sin repetir exactamente la misma actividad.</p></div>
      <div class="card"><div class="ico" style="background:#ccfbf1">📝</div><h3>Evaluaciones</h3><p>Recursos organizados para comprobar avances y acompañar la recuperación de contenidos.</p></div>
      <div class="card"><div class="ico" style="background:#fef3c7">🎲</div><h3>Juegos de Química</h3><p>Desafíos, clasificaciones y dinámicas participativas para repasar de una forma más activa.</p></div>
      <div class="card"><div class="ico" style="background:#ede9fe">📖</div><h3>Historietas científicas</h3><p>Los Chismes de la Tabla Periódica, Elementos Infieles y otras historias que convierten conceptos complejos en algo memorable.</p></div>
      <div class="card"><div class="ico" style="background:#e0f2f7">📂</div><h3>Documentos completos y fichas sueltas</h3><p>Imprime el tema entero o solo la ficha que necesitas para la clase de hoy.</p></div>
    </div>
    <div class="moments">
      <h3>Recursos para cada momento real del aula</h3>
      <div class="grid g4">
        <div class="m"><b>Explicar</b>cuando necesitas que la teoría sea más clara y visual.</div>
        <div class="m"><b>Practicar</b>cuando el curso necesita aplicar y afianzar.</div>
        <div class="m"><b>Evaluar</b>cuando necesitas comprobar avances sin crear todo de nuevo.</div>
        <div class="m"><b>Recuperar</b>cuando un estudiante o grupo necesita otra oportunidad.</div>
      </div>
    </div>
  </div>
</section>

<!-- MUESTRAS -->
<section class="samples">
  <div class="wrap">
    <div class="center narrow">
      <h2>Mira el material por dentro</h2>
      <p class="lead">Estas son algunas de las fichas, actividades y evaluaciones que recibes listas para imprimir.</p>
    </div>
    <div class="car">
      <button class="arr prev" aria-label="Anterior">‹</button>
      <div class="track" id="track">
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/oVi6a7zjfiG626jT4dxRqt/07_guia_visual_oxidos.webp" alt="Guía visual de óxidos"><p>Guía visual de óxidos</p><small>Ficha resumen</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/dXvyyxHpqRi75sa9WcqKyy/08_evaluacion_oxidos_a_b.webp" alt="Evaluación de óxidos versión A y B"><p>Evaluación de óxidos A/B</p><small>Evaluación</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/nErJPi2pwNRrU8XWGJA5TS/09_guia_estructura_atomica.webp" alt="Guía de estructura atómica"><p>Guía de estructura atómica</p><small>Ficha visual</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/r6UdwC9DAKb5T6TzYRFBB4/05_ficha_enlaces_quimicos.webp" alt="Ficha de enlaces químicos"><p>Enlaces químicos</p><small>Ficha visual</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/842jC1rTaueHjSQKGNZSor/01_detectives_tabla_periodica.webp" alt="Detectives de la tabla periódica"><p>Detectives de la tabla periódica</p><small>Juego</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/nHNCrqhcxeyW4c7bFD5TpR/02_particulas_detectives_impostores.webp" alt="Partículas: detectives de impostores"><p>Detectives de impostores</p><small>Actividad</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/xq8owfLgjrWoySWrkD5iLT/03_parque_clasificacion_materia.webp" alt="Clasificación de la materia"><p>Parque de clasificación de la materia</p><small>Actividad</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/szetLvTtB9aJjPh2TAcYXx/10_estados_materia.webp" alt="Estados de la materia"><p>Estados de la materia</p><small>Ficha visual</small></div>
      </div>
      <button class="arr next" aria-label="Siguiente">›</button>
      <div class="dots" id="dots"></div>
    </div>
    <p class="center cta-note" style="margin-top:20px">Fichas visuales · Actividades A/B · Evaluaciones · Juegos · Listo para imprimir</p>
  </div>
</section>

<!-- CUADERNILLOS -->
<section>
  <div class="wrap narrow">
    <div class="center">
      <span class="badge">Incluidos sin costo adicional</span>
      <h2>Y además, recibes los 5 cuadernillos visuales de apoyo.</h2>
      <p class="lead">Además de los recursos para resolver tus clases, tienes una guía ordenada para recorrer los contenidos durante el año.</p>
    </div>
    <div class="grid" style="margin-top:30px;gap:12px">
      <div class="book"><div class="n">1</div><div><b>Fundamentos de Química y sistemas materiales</b><p>Materia, propiedades, estados de agregación, modelo de partículas y transformaciones físicas y químicas.</p></div></div>
      <div class="book"><div class="n">2</div><div><b>Estructura atómica y tabla periódica</b><p>Modelos atómicos, partículas subatómicas, número atómico y másico, isótopos, iones y propiedades periódicas.</p></div></div>
      <div class="book"><div class="n">3</div><div><b>Configuración electrónica y enlaces químicos</b><p>Distribución electrónica, bloques de la tabla, enlaces iónicos, covalentes y metálicos, y estructuras de Lewis.</p></div></div>
      <div class="book"><div class="n">4</div><div><b>Química inorgánica y reacciones</b><p>Números de oxidación, formulación, nomenclatura, compuestos inorgánicos, reacciones, balanceo y estequiometría.</p></div></div>
      <div class="book"><div class="n">5</div><div><b>Química orgánica, salud y ambiente</b><p>Carbono, hidrocarburos, grupos funcionales, polímeros, bioquímica básica, salud y química ambiental.</p></div></div>
    </div>
    <p class="center closing-line">Los cuadernillos te ayudan a ordenar el año. Los recursos te ayudan a resolver la clase de hoy.</p>
  </div>
</section>

<!-- TESTIMONIOS -->
<section style="background:var(--ice)">
  <div class="wrap">
    <div class="center narrow">
      <h2>Lo que dicen docentes que ya trabajan con Química Visual</h2>
      <p class="lead">Mensajes que nos enviaron docentes después de usar el material en sus clases.</p>
    </div>
    <div class="wa">
      <img loading="lazy" src="https://cdn.magicpatterns.com/uploads/iG6779ACs1rKeTYacg57P4/testimonio_ximena_cdmx_quimica.webp" alt="Mensaje de WhatsApp de la profesora Ximena, CDMX">
      <img loading="lazy" src="https://cdn.magicpatterns.com/uploads/swe7TWhkTb2mtEry4kPx66/testimonio_beatriz_medellin_quimica.webp" alt="Mensaje de WhatsApp de la profesora Beatriz, Medellín">
      <img loading="lazy" src="https://cdn.magicpatterns.com/uploads/imUXRqUU2wHJvvEX8mcWzy/testimonio_javi_valencia_quimica.webp" alt="Mensaje de WhatsApp de Javi, profesor de Física y Química, Valencia">
    </div>
  </div>
</section>

<!-- DECISIÓN (reemplaza al contador) -->
<section class="decide" style="padding-top:10px">
  <div class="wrap narrow center">
    <h2>¿Cuánto te cuesta otra noche armando material?</h2>
    <p class="lead">Si preparar cada clase te lleva aunque sea una hora extra fuera del horario escolar, a lo largo del año eso son decenas de tardes que no vuelven.</p>
    <div class="calc">
      <div class="card"><div class="big">1 h</div><p>extra por clase buscando, adaptando o creando material</p></div>
      <div class="card"><div class="big">× año</div><p>todas las semanas, con uno o varios cursos</p></div>
      <div class="card"><div class="big g">1 pago</div><p>por recursos que vuelves a usar cada ciclo</p></div>
    </div>
  </div>
</section>

<!-- OFERTA -->
<section id="oferta">
  <div class="wrap narrow center">
    <h2>Recupera horas de planificación sin sumar otra tarea a tu lista.</h2>
    <p class="lead">Un solo pago. Acceso digital inmediato.</p>

    <div class="offer" style="margin-top:30px">
      <span class="tag">Precio especial</span>
      <h3>🧪 Química Visual™ — Edición LATAM</h3>
      <p style="color:var(--muted);font-size:.95rem">Todo lo que necesitas para explicar, practicar, evaluar y recuperar contenidos de Química en secundaria.</p>
      <ul>
        <li>Más de 200 actividades listas para imprimir y usar.</li>
        <li>Fichas visuales y ejemplos para explicar.</li>
        <li>Actividades y evaluaciones en versiones A y B.</li>
        <li>Juegos y desafíos para el aula.</li>
        <li>Historietas científicas: Los Chismes de la Tabla Periódica y Elementos Infieles.</li>
        <li>Recursos para práctica, evaluación y recuperación.</li>
        <li>Documentos completos y fichas individuales.</li>
        <li>5 cuadernillos visuales de apoyo, sin costo adicional.</li>
        <li>Acceso digital inmediato por correo electrónico.</li>
        <li>Garantía de satisfacción de 7 días.</li>
      </ul>
      <div class="pricebox">
        <span class="old" data-precio="antes">USD 49</span>
        <div class="now" data-precio="actual">USD 16,99</div>
        <div class="loc" id="locline" hidden></div>
        <div class="usd" id="usdline">Pago único. Sin suscripción.</div>
      </div>
    </div>

    <div style="margin-top:26px">
      <a class="btn big cta checkout" href="https://quimica-visual-secundaria.impultienda.ar/checkout">Quiero acceder a Química Visual</a>
      <p class="cta-note">💳 En el checkout pagas en tu moneda local con los medios de pago de tu país.</p>
      <p class="cta-sub">Serás redirigido a una pasarela de pago segura. Si no estás conforme, tienes 7 días para pedir la devolución de tu dinero.</p>
    </div>

    <div class="grid g4 trust4" style="margin-top:30px">
      <div class="card"><span>🔒</span>Pago protegido</div>
      <div class="card"><span>📩</span>Acceso inmediato</div>
      <div class="card"><span>🛡️</span>Garantía 7 días</div>
      <div class="card"><span>💱</span>Tu moneda local</div>
    </div>

    <div class="guar">
      <img src="https://cdn.magicpatterns.com/uploads/wPdBTd5Jo7F4dpjLi12DAp/garantia-7-dias-250.webp" alt="Garantía de 7 días" loading="lazy">
      <div>
        <h3>Garantía de satisfacción de 7 días</h3>
        <p style="color:var(--muted);margin-top:6px">Explora el material con tranquilidad. Si consideras que no es adecuado para tus necesidades, puedes solicitar la devolución dentro de los 7 días posteriores a la compra, de acuerdo con las condiciones de garantía.</p>
      </div>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="faq" style="background:var(--ice)">
  <div class="wrap narrow">
    <h2 class="center" style="margin-bottom:28px">Preguntas frecuentes</h2>
    <details open><summary>¿En qué formato recibo el material?</summary><p>Todos los recursos se entregan en PDF de alta calidad. Puedes imprimirlos, proyectarlos o usarlos desde una computadora, tableta o teléfono.</p></details>
    <details><summary>¿Qué estoy comprando exactamente?</summary><p>Accedes a Química Visual™: más de 200 actividades entre fichas visuales, actividades en versiones A y B, evaluaciones, juegos e historietas científicas listas para imprimir. Además, recibes sin costo adicional los 5 cuadernillos visuales de apoyo.</p></details>
    <details><summary>¿Sirve para el programa de mi país?</summary><p>El material trabaja los contenidos fundamentales de Química de secundaria. Cada docente puede seleccionar, organizar y adaptar los recursos según el programa de su país o institución.</p></details>
    <details><summary>¿Cómo recibo el acceso?</summary><p>Una vez confirmado el pago, recibes el acceso al material en el correo electrónico que indiques al comprar. Si no lo ves, revisa la carpeta de spam o promociones.</p></details>
    <details><summary>¿Es una suscripción?</summary><p>No. Es un pago único, sin suscripción ni renovaciones. Accedes al material y puedes volver a usarlo en los siguientes ciclos escolares.</p></details>
    <details><summary>¿En qué moneda pago?</summary><p>En la página ves un precio aproximado en tu moneda. En el checkout pagas en tu moneda local, con los medios de pago disponibles en tu país, y ves el monto exacto antes de confirmar.</p></details>
    <details><summary>¿Puedo usarlo en clases particulares o talleres?</summary><p>Sí. Puedes usarlo en instituciones educativas, clases particulares, espacios de apoyo y talleres de ciencias. El material no puede revenderse, compartirse públicamente ni distribuirse como producto propio.</p></details>
  </div>
</section>

<!-- CIERRE -->
<section class="final">
  <div class="wrap narrow">
    <h2>QUÍMICA VISUAL™<br><span>EDICIÓN LATAM</span></h2>
    <p class="sub">Tu próxima clase de Química no tiene que empezar desde cero.</p>
    <p style="margin:14px auto 28px;max-width:640px">Más de 200 actividades listas para explicar, practicar, evaluar y recuperar contenidos, para que vuelvas a reservar tiempo para enseñar, descansar o compartir fuera de la escuela.</p>
    <a class="btn big cta checkout" href="https://quimica-visual-secundaria.impultienda.ar/checkout">Acceder a los recursos ahora</a>
    <p class="meta">Material imprimible · Pago único · Acceso inmediato · Garantía de 7 días</p>
  </div>
</section>

<footer>
  <b>GUÍA DIGITAL360™</b>
  <p style="margin-top:6px">Química Visual™ © 2026</p>
  <p style="max-width:520px;margin:16px auto 0">Descargo de responsabilidad: los resultados pueden variar según cada docente, contexto institucional y modalidad de uso. El material es de carácter pedagógico y didáctico.</p>
</footer>

<div class="sticky" id="sticky">
  <div class="p antes-oferta">Química Visual™<small>+200 actividades listas para imprimir</small></div>
  <a class="btn cta antes-oferta" href="#oferta">Ver qué incluye</a>
  <div class="p despues-oferta"><span data-precio="actual">USD 16,99</span><small>Pago único · Acceso inmediato</small></div>
  <a class="btn cta checkout despues-oferta" href="https://quimica-visual-secundaria.impultienda.ar/checkout">Quiero acceder</a>
</div>`;
export function App() {
  useEffect(() => {
    // evita doble carga (se marca en el propio DOM, así funciona también al recargar la vista previa)
    const raiz = document.getElementById("particulas");
    if (!raiz || raiz.dataset.qvInit) return;
    raiz.dataset.qvInit = "1";
    try {
      // si algo falla, la página igual se ve (solo se pierde esa parte interactiva)
      document.documentElement.classList.add("js");
      document.title = "Química Visual™ — Recursos de Química listos para imprimir";

      // Fuentes
      if (!document.getElementById("qv-fonts")) {
        const l = document.createElement("link");
        l.id = "qv-fonts";
        l.rel = "stylesheet";
        l.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@600;700;800;900&display=swap";
        document.head.appendChild(l);
      }

      // Meta Pixel
      if (!window.fbq) {
        // Se agrega al <head>: no depende de que existan otros <script> en la página
        const fbq = function () {
          fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = "2.0";
        fbq.queue = [];
        window.fbq = fbq;
        if (!window._fbq) window._fbq = fbq;
        const sc = document.createElement("script");
        sc.async = true;
        sc.src = "https://connect.facebook.net/en_US/fbevents.js";
        document.head.appendChild(sc);
        window.fbq('init', '1075305848505674');
        window.fbq('track', 'PageView');
      }

      /* =========================================================
         CONFIGURACIÓN — editar solo esta parte
         ========================================================= */
      const PRECIO_USD = 16.99; // precio real
      const PRECIO_ANTES_USD = 49; // precio tachado
      const CHECKOUT_URL = "https://quimica-visual-secundaria.impultienda.ar/checkout";

      // Precios fijos opcionales por país (si se completan, reemplazan la conversión).
      // Ponerlos IGUALES a lo que cobra el checkout. Ej: AR: { actual: 24900, antes: 69900 }
      const PRECIOS_FIJOS = {
        AR: {
          actual: 25813,
          antes: 74600
        } // igual al checkout de impultienda (06/10/2026: AR$ 25.813). Actualizar si cambia.
      };

      // País -> moneda, decimales a mostrar y nombre
      const PAISES = {
        AR: {
          m: "ARS",
          d: 0,
          n: "Argentina"
        },
        MX: {
          m: "MXN",
          d: 0,
          n: "México"
        },
        CO: {
          m: "COP",
          d: 0,
          n: "Colombia"
        },
        CL: {
          m: "CLP",
          d: 0,
          n: "Chile"
        },
        PE: {
          m: "PEN",
          d: 2,
          n: "Perú"
        },
        UY: {
          m: "UYU",
          d: 0,
          n: "Uruguay"
        },
        PY: {
          m: "PYG",
          d: 0,
          n: "Paraguay"
        },
        BO: {
          m: "BOB",
          d: 2,
          n: "Bolivia"
        },
        EC: {
          m: "USD",
          d: 2,
          n: "Ecuador"
        },
        VE: {
          m: "USD",
          d: 2,
          n: "Venezuela"
        },
        GT: {
          m: "GTQ",
          d: 2,
          n: "Guatemala"
        },
        CR: {
          m: "CRC",
          d: 0,
          n: "Costa Rica"
        },
        DO: {
          m: "DOP",
          d: 0,
          n: "República Dominicana"
        },
        HN: {
          m: "HNL",
          d: 2,
          n: "Honduras"
        },
        NI: {
          m: "NIO",
          d: 2,
          n: "Nicaragua"
        },
        PA: {
          m: "USD",
          d: 2,
          n: "Panamá"
        },
        SV: {
          m: "USD",
          d: 2,
          n: "El Salvador"
        },
        PR: {
          m: "USD",
          d: 2,
          n: "Puerto Rico"
        },
        ES: {
          m: "EUR",
          d: 2,
          n: "España"
        },
        US: {
          m: "USD",
          d: 2,
          n: "Estados Unidos"
        },
        BR: {
          m: "BRL",
          d: 2,
          n: "Brasil"
        }
      };

      // Tipos de cambio de respaldo (solo si falla la consulta en vivo). Aproximados.
      const TASAS_RESPALDO = {
        USD: 1,
        ARS: 1450,
        MXN: 18.5,
        COP: 3900,
        CLP: 950,
        PEN: 3.6,
        UYU: 40,
        PYG: 7300,
        BOB: 6.96,
        GTQ: 7.7,
        CRC: 505,
        DOP: 63,
        HNL: 26,
        NIO: 36.7,
        EUR: 0.86,
        BRL: 5.4
      };

      /* ========================================================= */

      const $$ = s => document.querySelectorAll(s);
      function redondear(v, d) {
        if (d === 0) return v >= 10000 ? Math.round(v / 100) * 100 : v >= 1000 ? Math.round(v / 10) * 10 : Math.round(v);
        return Math.round(v * 100) / 100;
      }
      function formatear(v, m, d) {
        const num = new Intl.NumberFormat("es-AR", {
          minimumFractionDigits: d,
          maximumFractionDigits: d
        }).format(v);
        if (m === "EUR") return num + " €";
        if (m === "USD") return "USD " + num;
        const sim = {
          PEN: "S/ ",
          BOB: "Bs ",
          GTQ: "Q ",
          CRC: "₡",
          PYG: "₲ ",
          HNL: "L ",
          NIO: "C$ ",
          BRL: "R$ "
        }[m] || "$";
        return sim + num + " " + m;
      }
      async function detectarPais() {
        const forzado = new URLSearchParams(location.search).get("pais"); // prueba: ?pais=AR
        if (forzado) return forzado.toUpperCase();
        try {
          const c = sessionStorage.getItem("qv_pais");
          if (c) return c;
        } catch (e) {}
        const guardar = c => {
          try {
            sessionStorage.setItem("qv_pais", c);
          } catch (e) {}
          return c;
        };
        // Nota: NO usar /cdn-cgi/trace — Magic Patterns pasa por un servidor en EE.UU. y siempre devuelve "US".
        try {
          const j = await (await fetch("https://get.geojs.io/v1/ip/country.json")).json();
          if (j && j.country) return guardar(j.country.toUpperCase());
        } catch (e) {}
        try {
          const j = await (await fetch("https://ipwho.is/?fields=country_code")).json();
          if (j && j.country_code) return guardar(j.country_code.toUpperCase());
        } catch (e) {}
        const lang = (navigator.language || "").split("-")[1];
        return lang ? lang.toUpperCase() : null;
      }
      async function tasa(m) {
        if (m === "USD") return 1;
        try {
          const cache = JSON.parse(sessionStorage.getItem("qv_tasas") || "null");
          if (cache && cache.rates && cache.rates[m]) return cache.rates[m];
        } catch (e) {}
        try {
          const j = await (await fetch("https://open.er-api.com/v6/latest/USD")).json();
          if (j && j.rates) {
            try {
              sessionStorage.setItem("qv_tasas", JSON.stringify({
                rates: j.rates
              }));
            } catch (e) {}
            ;
            if (j.rates[m]) return j.rates[m];
          }
        } catch (e) {}
        return TASAS_RESPALDO[m] || null;
      }
      async function aplicarMoneda() {
        const pais = await detectarPais();
        const cfg = pais && PAISES[pais];
        if (!cfg) return; // se queda en USD
        let actual,
          antes,
          aprox = true;
        if (PRECIOS_FIJOS[pais]) {
          actual = PRECIOS_FIJOS[pais].actual;
          antes = PRECIOS_FIJOS[pais].antes;
          aprox = false;
        } else {
          const r = await tasa(cfg.m);
          if (!r) return;
          actual = redondear(PRECIO_USD * r, cfg.d);
          antes = redondear(PRECIO_ANTES_USD * r, cfg.d);
          if (cfg.m === "USD") aprox = false;
        }
        const pre = aprox ? "≈ " : "";
        $$('[data-precio="actual"]').forEach(e => e.textContent = pre + formatear(actual, cfg.m, cfg.d));
        $$('[data-precio="antes"]').forEach(e => e.textContent = formatear(antes, cfg.m, cfg.d));
        const flag = `<img src="https://flagcdn.com/w40/${pais.toLowerCase()}.png" alt="">`;
        const loc = document.getElementById("locline");
        loc.innerHTML = `${flag} Precio para ${cfg.n}${aprox ? " (aproximado)" : ""}`;
        loc.hidden = false;
        if (cfg.m !== "USD") document.getElementById("usdline").textContent = `Equivale a USD ${PRECIO_USD.toFixed(2).replace(".", ",")}. El monto exacto en tu moneda lo ves en el checkout antes de pagar. Pago único.`;
        document.getElementById("topbar").innerHTML = `${flag}Disponible en ${cfg.n} · Acceso digital inmediato`;
        window.QV_PAIS = pais;
        window.QV_MONEDA = cfg.m;
      }
      aplicarMoneda();

      /* Pixel: InitiateCheckout al ir al checkout */
      $$(".checkout").forEach(a => a.addEventListener("click", () => {
        try {
          window.fbq("track", "InitiateCheckout", {
            value: PRECIO_USD,
            currency: "USD",
            content_name: "Química Visual LATAM"
          });
        } catch (e) {}
      }));

      /* Carrusel */
      (function () {
        const track = document.getElementById("track"),
          dots = document.getElementById("dots");
        const slides = track.children,
          n = slides.length;
        for (let i = 0; i < n; i++) {
          const b = document.createElement("button");
          b.setAttribute("aria-label", "Muestra " + (i + 1));
          b.onclick = () => ir(i);
          dots.appendChild(b);
        }
        const ir = i => track.scrollTo({
          left: slides[(i + n) % n].offsetLeft - track.offsetLeft,
          behavior: "smooth"
        });
        const actual = () => Math.round(track.scrollLeft / track.clientWidth);
        const marcar = () => [...dots.children].forEach((d, i) => d.classList.toggle("on", i === actual()));
        track.addEventListener("scroll", () => requestAnimationFrame(marcar));
        document.querySelector(".arr.prev").onclick = () => ir(actual() - 1);
        document.querySelector(".arr.next").onclick = () => ir(actual() + 1);
        marcar();
      })();

      /* Flecha animada dentro de cada CTA */
      $$(".btn.big, .btn.cta").forEach(b => {
        if (!b.querySelector(".fl")) b.insertAdjacentHTML("beforeend", ' <span class="fl">→</span>');
      });

      /* Aparición al hacer scroll */
      (function () {
        const els = $$("h2, .card, .book, .slide, .offer, .guar, .wa img, .moments, .faq details");
        els.forEach((e, i) => {
          e.classList.add("rv");
          e.style.transitionDelay = i % 3 * 90 + "ms";
        });
        if (!("IntersectionObserver" in window)) {
          els.forEach(e => e.classList.add("in"));
          return;
        }
        const io = new IntersectionObserver(es => es.forEach(x => {
          if (x.isIntersecting) {
            x.target.classList.add("in");
            io.unobserve(x.target);
            setTimeout(() => x.target.style.transitionDelay = "", 1000);
          }
        }), {
          threshold: .12
        });
        els.forEach(e => io.observe(e));
      })();

      /* Partículas flotantes: átomos, electrones, protones y neutrones */
      (function () {
        if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const capa = document.getElementById("particulas");
        const movil = innerWidth < 760;
        const N = movil ? 9 : 18;
        const atomo = (c1, c2) => `<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="9" fill="${c1}"/>
    <g class="orb" style="--g:7s"><ellipse cx="50" cy="50" rx="44" ry="16" fill="none" stroke="${c2}" stroke-width="2.5"/><circle cx="94" cy="50" r="5" fill="${c2}"/></g>
    <g class="orb r" style="--g:9s"><ellipse cx="50" cy="50" rx="44" ry="16" fill="none" stroke="${c2}" stroke-width="2.5" transform="rotate(60 50 50)"/><circle cx="72" cy="88" r="5" fill="${c2}"/></g>
    <g class="orb" style="--g:11s"><ellipse cx="50" cy="50" rx="44" ry="16" fill="none" stroke="${c2}" stroke-width="2.5" transform="rotate(-60 50 50)"/><circle cx="28" cy="88" r="5" fill="${c2}"/></g></svg>`;
        const bola = (c, t) => `<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="${c}"/><text x="50" y="64" text-anchor="middle" font-family="Poppins,sans-serif" font-weight="800" font-size="40" fill="#fff">${t}</text></svg>`;
        const tipos = [{
          html: () => atomo("#2563eb", "#14b8a6"),
          s: [60, 110],
          o: .15
        }, {
          html: () => atomo("#0f6a82", "#2563eb"),
          s: [50, 90],
          o: .14
        }, {
          html: () => bola("#ef4444", "+"),
          s: [18, 30],
          o: .22
        },
        // protón
        {
          html: () => bola("#64748b", "n"),
          s: [18, 28],
          o: .20
        },
        // neutrón
        {
          html: () => bola("#14b8a6", "e⁻"),
          s: [12, 20],
          o: .26
        },
        // electrón
        {
          html: () => bola("#2563eb", "e⁻"),
          s: [12, 18],
          o: .24
        }];
        const r = (a, b) => a + Math.random() * (b - a);
        for (let i = 0; i < N; i++) {
          const t = tipos[i % tipos.length],
            s = r(t.s[0], t.s[1]) * (movil ? .75 : 1);
          const d = document.createElement("div");
          d.className = "pt";
          // la mayoría por los costados para no tapar el texto central
          const lado = Math.random() < .8 ? Math.random() < .5 ? r(0, 14) : r(84, 97) : r(15, 84);
          d.style.cssText = `left:${lado}vw;top:${r(0, 95)}vh;width:${s}px;height:${s}px;--o:${t.o};--t:${r(18, 34)}s;animation-delay:-${r(0, 20)}s;` + `--dx1:${r(-60, 60)}px;--dy1:${r(-90, 90)}px;--dx2:${r(-80, 80)}px;--dy2:${r(-120, 120)}px;--dx3:${r(-50, 50)}px;--dy3:${r(-80, 80)}px`;
          d.innerHTML = t.html();
          capa.appendChild(d);
        }
        // leve paralaje con el scroll
        addEventListener("scroll", () => {
          capa.style.transform = `translateY(${Math.sin(scrollY / 500) * 30}px)`;
        }, {
          passive: true
        });
      })();

      /* Barra fija en móvil: aparece después del hero, se oculta en la oferta */
      (function () {
        const s = document.getElementById("sticky"),
          hero = document.querySelector(".hero"),
          of = document.getElementById("oferta");
        const upd = () => {
          const pasóHero = hero.getBoundingClientRect().bottom < 0;
          const r = of.getBoundingClientRect(),
            enOferta = r.top < innerHeight && r.bottom > 0;
          s.classList.toggle("show", pasóHero && !enOferta);
          // Antes de la oferta: sin precio, lleva a #oferta. Después de la oferta: precio + checkout.
          s.classList.toggle("pasada", r.bottom <= 0);
        };
        addEventListener("scroll", upd, {
          passive: true
        });
        upd();
      })();

      /* Botones que llevan a la oferta: scroll propio de ~0,9 s que termina SIEMPRE en el título de la oferta.
         Recalcula el destino en cada cuadro porque las imágenes (testimonios, carrusel) se cargan mientras baja y empujan la oferta. */
      (function () {
        const destino = () => {
          const t = document.querySelector("#oferta h2") || document.getElementById("oferta");
          return Math.max(0, t.getBoundingClientRect().top + scrollY - 24);
        };
        const html = document.documentElement;
        const ease = p => p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
        $$('a[href="#oferta"]').forEach(a => a.addEventListener("click", e => {
          e.preventDefault();
          // carga ya las imágenes que hay en el camino, así no cambian la altura después
          $$('img[loading="lazy"]').forEach(img => {
            img.loading = "eager";
          });
          const prev = html.style.scrollBehavior;
          html.style.scrollBehavior = "auto";
          const y0 = scrollY,
            dur = 900,
            t0 = performance.now();
          const paso = now => {
            const p = Math.min(1, (now - t0) / dur);
            scrollTo(0, y0 + (destino() - y0) * ease(p));
            if (p < 1) requestAnimationFrame(paso);else {
              // corrección final por si algo terminó de cargar justo al llegar
              let n = 0;
              const fijar = () => {
                scrollTo(0, destino());
                if (++n < 3) setTimeout(fijar, 150);else html.style.scrollBehavior = prev;
              };
              fijar();
            }
          };
          requestAnimationFrame(paso);
        }));
      })();
    } catch (err) {
      console.error("Química Visual init:", err);
    }
  }, []);
  return <>
      <style data-id="element-0" data-mp="qk8jnsxkv11k">{CSS}</style>
      <div id="particulas" aria-hidden="true" data-id="element-1" data-mp="qjqhygs5bum9"></div>
      <div dangerouslySetInnerHTML={{
      __html: MARKUP
    }} data-id="element-2" data-mp="qmcl84807nyo" />
    </>;
}
export default App;